<template>
    <v-container fluid class="pa-0 pb-8">
        <v-container class="container-custom">
            <Breadcrumbs :title="'Refinanciar'"></Breadcrumbs>
            <v-row justify="center">
                <v-col class="viewSpaces" sm="9">
                    <v-card>
                        <v-card-text>
                            <v-row>
                                <v-col class="col-4">
                                    <span class="body-1 primary--text font-weight-bold text-h6">Legajo:</span>
                                </v-col>
                                <v-col class="col-8">
                                    <span class="text-h6">{{ $route.params.studentRecord }}</span>
                                </v-col>
                            </v-row>

                            <v-divider></v-divider>

                            <v-row>
                                <v-col class="col-4">
                                    <span class="body-1 primary--text font-weight-bold text-h6">Deuda total:</span>
                                </v-col>
                                <v-col class="col-8">
                                    <span class="text-h6 pl-2">€ {{ Math.round(debtAmount) }}</span>
                                </v-col>
                            </v-row>

                            <v-divider></v-divider>

                            <v-row>
                                <v-col class="col-4">
                                    <span class="body-1 primary--text font-weight-bold text-h6">Deuda a refinanciar:</span>
                                </v-col>
                                <v-col class="col-8">
                                    <span class="text-h6 pl-2">€ {{ Math.round(refinanceAmount) }}</span>
                                
                                    <span class="caption text-muted">  *Excluye trámites y productos de facturación
                                        individual</span>
                                </v-col>
                            </v-row>

                            <v-divider></v-divider>

                            <v-row>
                                <v-col class="col-4">
                                    <span class="body-1 primary--text font-weight-bold text-h6">Plazos:</span>
                                </v-col>
                                <v-col class="col-3">
                                    <v-select v-model="installments" :items="installmentOptions"></v-select>
                                </v-col>
                            </v-row>

                            <v-divider></v-divider>

                            <v-row>
                                <v-col class="col-4">
                                    <span class="body-1 primary--text font-weight-bold text-h6">Mes de vencimiento:</span>
                                </v-col>
                                <v-col class="col-8">
                                    <VueDatePicker v-model="dueDate" fullscreen-mobile type="month" no-header
                                        placeholder="MM YYYY" :locale="{ lang: 'es' }" />
                                </v-col>
                            </v-row>
                        </v-card-text>

                        <v-card-actions>
                            <v-col cols="12" class="text-right">
                                <v-btn @click="showConfirmationDialog" :disabled="disableRefinance" color="primary">Refinanciar</v-btn>
                            </v-col>
                        </v-card-actions>
                        <v-alert v-if="disableRefinance"  type="error" >No se permite la refinanciación de matrícula o trámites</v-alert>
                    </v-card>
                </v-col>
            </v-row>


            <v-dialog v-model="confirmationDialog" max-width="400">
                <v-card>
                    <v-card-title class="headline">Confirmación</v-card-title>
                    <v-card-text>
                        ¿Está seguro de que desea refinanciar la deuda?
                    </v-card-text>
                    <v-divider></v-divider>
                    <br>
                    <v-card-text>
                        Legajo: <span class="font-weight-bold">{{ $route.params.studentRecord }}</span>
                    </v-card-text>
                    <v-card-text>
                        Deuda a refinanciar: <span class="font-weight-bold">€ {{ Math.round(refinanceAmount) }}</span>
                    </v-card-text>
                    <v-card-text>
                        Plazos: <span class="font-weight-bold">{{ installments }}</span>
                    </v-card-text>
                    <v-card-text>
                        Primer vto: <span class="font-weight-bold">{{ dueDate }}</span>
                    </v-card-text>
                    <v-card-text>
                        Monto <span class="font-weight-bold">aproximado</span> a pagar por plazo:
                        <span class="font-weight-bold">€{{ Math.round((refinanceAmount - (refinanceAmount * (formattedDiscountInput /
                            100))) /
                            installments) }}</span>
                    </v-card-text>
                    <v-divider></v-divider>
                    <br>
                    <v-card-actions>
                        <v-btn @click="refinance" :disabled="disableRefinance" color="primary" :loading=this.loading>Refinanciar</v-btn>
                        <v-btn @click="closeConfirmationDialog" color="error">Cerrar</v-btn>
                    </v-card-actions>
                    <v-alert v-if="disableRefinance"  type="error" >No se permite la refinanciación de matrícula o trámites</v-alert>
                </v-card>
            </v-dialog>
        </v-container>
    </v-container>
</template>

<script>


import Breadcrumbs from '@/components/Breadcrumbs/Breadcrumbs';
import { VueDatePicker } from '@mathieustan/vue-datepicker';
import { $studentAccount } from '../Services';
import { mapGetters } from 'vuex';

export default {
    name: 'Refinance',
    components: {
        Breadcrumbs,
        VueDatePicker
    },
    mounted() {
        this.initialize();
    },
    data() {
        return {
            payments: [],
            refinanceitems: [],
            debtAmount: 0,
            refinanceAmount: 0,
            installments: 1,
            dueDate: null,
            discount: null,
            formattedDiscountInput: 0,
            loading: false,
            installmentOptions: Array.from({ length: 18 }, (_, i) => i + 1),
            pagination: {
                limit: 20,
                page: 1,
                pageAmount: 1
            },
            sort: {
                sortBy: 'id',
                sortDesc: false,
            },
            confirmationDialog: false,
        };
    },
    computed: {
        ...mapGetters({
            getLoggedUser: 'commons/getUserID'
        }),
        disableRefinance() {
            const disabled = this.payments.some(payment => payment.isBilledIndividually || payment.isProcedure);
            return disabled;
        }
    },
    methods: {
        initialize() {
            this.getPayments();
        },
        async getPayments() {
            try {
                const params = {
                    page: 0,
                    length: 100,
                    orderBy: this.sort.sortBy,
                    orientation: this.sort.sortDesc ? 'desc' : 'asc',
                    search: ''
                }
                const response = await $studentAccount.findById(this.$route.params.studentRecord, 'adjustment', { params });
                const { data } = response
                this.payments = data.accounts.content.map(account => {
                    account.accountDescription = account.isBilledIndividually ? this.$t('modules.exceptions.payments.labels.tuition') : account.accountDescription
                    return account
                })

                this.payments.sort((a, b) => new Date(b.expiration) - new Date(a.expiration));
                this.payments = this.payments.filter(payment => (payment.paymentStatus.value == 123
                    || payment.paymentStatus.value == 115 || payment.paymentStatus.value == 117));
                this.totalItems = data.accounts.totalElements
                this.debtAmount = this.payments.reduce((acc, payment) => acc + payment.paymentAmount, 0);
                this.refinanceitems = this.payments.filter(payment => !payment.isProcedure && !payment.isBilledIndividually);
                this.refinanceAmount = this.refinanceitems.reduce((acc, payment) => acc + payment.paymentAmount, 0);
            } catch (error) {
                this.payments = [];
            }
        },
        validateDiscountInput() {
            const discountInput = parseFloat(this.formattedDiscountInput);
            if (!isNaN(discountInput) && discountInput >= -75 && discountInput <= 75) {
                this.formattedDiscountInput = (discountInput * 100) / 100;
            } else {
                this.formattedDiscountInput = 0;
            }
        },
        showConfirmationDialog() {
            this.confirmationDialog = true;
        },
        closeConfirmationDialog() {
            this.confirmationDialog = false;
        },
        async refinance() {
            this.loading = true;
            const inputDate = new Date(`${this.dueDate}-05T00:00:00Z`);
            const requestDate = inputDate.toISOString();
            const body = {
                installments: this.installments,
                expiration: requestDate,
                discount: this.formattedDiscountInput,
                userId: this.getLoggedUser
            }
            try {
                const response = await $studentAccount.postRefinance(this.$route.params.studentRecord, body);
                this.loading = false;
                this.confirmationDialog = false;
                if (response) {
                    this.$store.dispatch('commons/openPopUp', {
                        title: 'Refinanciar deuda',
                        content: [{ value: '¡La deuda fue refinanciada con éxito!' }],
                        actionPrimary: { text: 'Ok', callback() { } },
                        icon: { color: 'success', name: 'mdi-check' },
                        color: 'primary',
                    });
                }
            }
            catch (error) {
                this.loading = false;
                this.confirmationDialog = false;
                this.$store.dispatch('commons/openPopUp', {
                    title: 'Refinanciar deuda',
                    content: [{ value: '¡Error al refinanciar la deuda!' }],
                    actionPrimary: { text: 'Ok', callback() { } },
                    icon: { color: 'error', name: 'mdi-alert' },
                    color: 'primary',
                });
            }
        },
    },
}

</script>